module.exports = __webpack_public_path__ + "img/GALLERY-SWIFT-4.f27daeab.jpg";